import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { LanguageProvider } from './i18n/translations';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { TopInfoBar } from './components/TopInfoBar';
import AccessGate from './components/AccessGate';

import Home from './pages/Home';
import Ponuda from './pages/Ponuda';
import PonudaDetail from './pages/PonudaDetail';
import Mapa from './pages/Mapa';
import Kalendar from './pages/Kalendar';
import Obavijesti, { ObavijestDetail } from './pages/Obavijesti';
import Kontakt from './pages/Kontakt';
import ONama from './pages/ONama';
import Prijava from './pages/Prijava';
import Registracija from './pages/Registracija';

import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminObavijesti from './pages/admin/AdminObavijesti';
import AdminDogadjaji from './pages/admin/AdminDogadjaji';
import AdminPonuda from './pages/admin/AdminPonuda';
import AdminTipovi from './pages/admin/AdminTipovi';
import AdminKorisnici from './pages/admin/AdminKorisnici';
import AdminUloge from './pages/admin/AdminUloge';
import AdminIzvjestaji from './pages/admin/AdminIzvjestaji';
import MojObjekat from './pages/admin/MojObjekat';

function PublicLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <TopInfoBar />
      <Navbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  const [gateOk, setGateOk] = useState(() => !!localStorage.getItem('eturizam_gate'));

  if (!gateOk) {
    return (
      <div className="App">
        <AccessGate onSuccess={() => setGateOk(true)} />
      </div>
    );
  }

  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/ponuda" element={<Ponuda />} />
                <Route path="/ponuda/:id" element={<PonudaDetail />} />
                <Route path="/mapa" element={<Mapa />} />
                <Route path="/kalendar" element={<Kalendar />} />
                <Route path="/obavijesti" element={<Obavijesti />} />
                <Route path="/obavijesti/:id" element={<ObavijestDetail />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/o-nama" element={<ONama />} />
                <Route path="/prijava" element={<Prijava />} />
                <Route path="/registracija" element={<Registracija />} />
              </Route>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="obavijesti" element={<AdminObavijesti />} />
                <Route path="dogadjaji" element={<AdminDogadjaji />} />
                <Route path="ponuda" element={<AdminPonuda />} />
                <Route path="tipovi" element={<AdminTipovi />} />
                <Route path="korisnici" element={<AdminKorisnici />} />
                <Route path="uloge" element={<AdminUloge />} />
                <Route path="izvjestaji" element={<AdminIzvjestaji />} />
                <Route path="moj-objekat" element={<MojObjekat />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
